







































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Configuration, TitleTemplatePublic, RedCapital, SelectedCountry, RedCapitalConfig } from '@/configuration'
import API from '@/api'
import { EventBus } from '@/main'
import DniField from '@/components/DniField.vue'
import { DniTrim } from '@/utils'
//@ts-ignore
import gRecaptcha from '@finpo/vue2-recaptcha-invisible';

@Component({
  metaInfo: {
    title: 'Recuperar contraseña',
    titleTemplate: TitleTemplatePublic,
    htmlAttrs: {
      // @ts-ignore
      lang: RedCapital[SelectedCountry].Lang,
    }
  },
  data(){
    return{
      token:'',
      valid: false,
      canPress: true,
      dni: '',
      dialog: false,
      errorMessage: null,
    }
  },
  watch:{
    dni() {
      this.$data.errorMessage = null
      // @ts-ignore
      this.$data.valid = this.$refs.form.validate()
    },
  },
  methods:{
    validate() {
      // validate your form , if you don't have validate prop , default validate pass .
      return true;
    },
    callback(token) {
      // google recaptcha token , then you can pass to backend with your form data .
      if (token) {
        this.$data.token = token
        //@ts-ignore
        this.validatefrom()
      }else{
        // if you use data-size show reCAPTCHA , maybe you will get empty token.
       // alert('please check you are not robot');
        this.$data.canPress = true;
        this.$data.errorMessage = "Error";
      }
    },
    validatefrom() {
 
      this.$data.canPress = false
      API.recover(this.$data.token,DniTrim.string(this.$data.dni)).then( data => {
        this.$data.dialog = true
        setTimeout(() => {
          this.$router.push({
            path: '/'
          })
        }, 2500)
      }).catch( res => {
        this.$data.canPress = true
        this.$data.errorMessage = res.message
        EventBus.$emit('snack-error', this.$data.errorMessage)
      })
    }
  },
  components: {
    DniField,
    gRecaptcha
  },
})
export default class Recover extends Vue {}
